<button
  type="button"
  class="back-button"
  [class.with-bg]="withBg"
  (click)="openPreviousOrHome()"
  dataTest="btn-back"
>
  <span class="icon icon-community-chevron"></span>
  @if (text) {
    <span class="argo-back-text">{{ text }}</span>
  }
</button>
